const resource = '/admin/v1/tags';

export default $axios => ({
  index(page) {
    return $axios.get(`${resource}?page=${page}`);
  },

  getList(page) {
    return $axios.get(`${resource}/get-list?page=${page}`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  getListByAdmin(){
    return $axios.get(`${resource}/create-by-admin`);
  }
});
